
























import { Component, Vue, Prop } from "vue-property-decorator";
@Component({})
export default class ResearchComposeChanhou extends Vue {
  @Prop()
  private message: any;
}
